import { GraphQLClient } from 'graphql-request';
import { getToken } from '../Utils/Token';
import config from '../Config/Environment';

const graphql = async (name, properties, type = 'query', params = null) => {
  const token = getToken();
  let graphQLClient;
  if (token) {
    graphQLClient = new GraphQLClient(`${config.endpoint}/`, {
      headers: {
        authorization: token ? `Bearer ${token}` : '',
      },
    });
  } else {
    graphQLClient = new GraphQLClient(`${config.endpoint}/`);
  }

  if (!params) {
    const query = `
      ${type} {
        ${name} {
          ${properties}
        }
      }
    `;
    return graphQLClient.request(query);
  }

  const keys = Object.keys(params);
  const values = Object.values(params);
  const param = keys.map((key, index) => `${key}:"${values[index]}"`).join();

  const query = `
    ${type} {
      ${name}(${param}) {
        ${properties}
      }
    }
  `;

  return graphQLClient.request(query).catch(e => {
    return {
      error: true,
      errorMessage: e.response.errors[0].message,
    };
  });
};

export default graphql;
